import type { CardInsight } from '../../../hooks/useAdvancedInsights';

interface Props { cards: CardInsight[]; }

const fmt = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const typeStyle: Record<CardInsight['type'], { bar: string; icon: string; text: string; bg: string }> = {
  warning: { bar: 'bg-red-400', icon: 'ri-error-warning-line', text: 'text-red-500', bg: 'bg-red-50' },
  info: { bar: 'bg-amber-400', icon: 'ri-information-line', text: 'text-amber-600', bg: 'bg-amber-50' },
  success: { bar: 'bg-emerald-400', icon: 'ri-checkbox-circle-line', text: 'text-emerald-600', bg: 'bg-emerald-50' },
};

export const InsightsCardsSection = ({ cards }: Props) => {
  if (!cards.length) return null;
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-sky-50 rounded-xl">
          <i className="ri-bank-card-line text-sky-500 text-[16px]" />
        </div>
        <div>
          <h2 className="text-[15px] font-700 text-gray-900">Cartões &amp; Faturas</h2>
          <p className="text-[12px] text-gray-400">Uso e gastos dos seus cartões este mês</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {cards.map((card) => {
          const s = typeStyle[card.type];
          return (
            <div key={card.cardName} className="bg-white rounded-2xl border border-gray-100 p-4">
              <div className="flex items-center justify-between mb-3">
                <p className="text-[13px] font-700 text-gray-800 truncate">{card.cardName}</p>
                <div className={`w-7 h-7 flex items-center justify-center ${s.bg} rounded-xl`}>
                  <i className={`${s.icon} ${s.text} text-[14px]`} />
                </div>
              </div>
              <p className="text-[22px] font-700 text-gray-900 mb-1">{fmt(card.totalSpent)}</p>
              {card.limit && (
                <div className="mb-3">
                  <div className="flex justify-between text-[11px] text-gray-400 mb-1">
                    <span>Limite usado</span>
                    <span>{card.usagePercent}%</span>
                  </div>
                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div className={`h-full rounded-full ${s.bar}`} style={{ width: `${Math.min(100, card.usagePercent ?? 0)}%` }} />
                  </div>
                </div>
              )}
              {card.topCategory && <p className="text-[11px] text-gray-400 mb-1">Maior gasto: <span className="font-600 text-gray-600">{card.topCategory}</span></p>}
              <p className={`text-[12px] ${s.text} font-400`}>{card.message}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
